<template>
  <div v-if="active" class="dropdown-menu" :class="{ show: sharedState.active }">
    <slot :close="handleClose" />
  </div>
</template>

<script>
export default {
  name: 'DropdownContent',
  inject: ['sharedState'],
  computed: {
    active() {
      return this.sharedState.active;
    }
  },
  methods: {
    handleClose() {
      this.sharedState.active = false;
    }
  }
};
</script>
